<template>
  <div class="mandati">

    <gnetHeader v-bind:logo="$store.state.logoimage"></gnetHeader>

    <gnetTabBar
      v-bind:titoloapp="'Portale Clienti'"
      v-bind:tabs="$store.state.tabs"
      v-bind:active_tab="$store.state.active_tab"
      v-on:click="changeTab($event)"
    />

    <div class="slds-grid">
      <div v-bind:class="{ 'slds-col slds-size_2-of-3': showTimeline, 'slds-col slds-size_11-of-12': !showTimeline }">

        <template v-if="listmode" >
<!--
            <gnetExpandable v-on:click="listdocumenti=!listdocumenti" v-bind:title="'Documenti'" v-bind:actions="documentiActions" v-on:change="actionClick($event)" v-bind:opened='listdocumenti'>
              <gnetTable
                v-bind:cols="documenticols"
                v-bind:records="documenti"
                v-on:click="click($event)"
                v-on:filter="filter($event)">
              </gnetTable>
            </gnetExpandable>
-->
            <gnetExpandable v-bind:title="'Scatti per gli articoli ordinati'" v-bind:actions="ordiniActions" v-bind:opened='true' v-on:change="changeOrdini($event)" >
              <gnetTabs v-bind:tabs="$store.state.campagne" v-on:change="changeCampagnaOrdini($event)" v-bind:multi="false" v-bind:multidefault="filtrocampagneO">
                <template v-slot:main>
                  <gnetTable
                    v-bind:cols="ordinidetailcols"
                    v-bind:records="ordinidetail"
                    v-on:click="clickArticle($event)"
                    v-on:filter="filter($event)">
                  </gnetTable>
                </template>
              </gnetTabs>
            </gnetExpandable>
            <a v-show="false" v-bind:href="csvdata" v-bind:download="'prodotti.csv'" id="downloadcsv">Scarica CSV</a>

        </template>
      </div>

    </div>

    <gnetSpinner v-bind:busy="busy"></gnetSpinner>
    <modal v-if="showElenco" v-bind:savetext="downloadready?'Scarica tutti':(foto.length?'recupero immagini in corso':'')" v-bind:canceltext="'Chiudi'" v-bind:wmode="false" v-bind:title="'Elenco scatti'" v-bind:hspace="'small'" v-on:submit="downloadAll()" v-on:cancel="showElenco=false">

      <div class="pippo slds-scrollable">
        <table v-if="foto.length" class="slds-table slds-table_cell-buffer slds-table_bordered slds-table_col-bordered slds-table_striped">

          <thead>
            <tr class="slds-line-height_reset">
              <th v-for="(col, index) in colsfoto" v-bind:key="col.order" style="vertical-align:top" v-on:click="$emit('filter',index)" >
                <span class="pippo"  >{{$t(col.label)}}</span>

                <svg v-if="col.filtered" class="slds-icon slds-icon-text-default slds-icon_x-small" aria-hidden="true">
                  <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#filterList"></use>
                </svg>
              </th>
            </tr>
          </thead>

          <tbody>
            <tr v-on:click="$emit('row',rindex)" v-for="(record, rindex) in foto" v-bind:key="record.id" class="slds-hint-parent">

              <td v-for="(col,index) in colsfoto" v-bind:key="col.order" v-bind:style="'text-align:'+align(col.type)" class="slds-truncate">

                <a v-if="index==0" v-bind:href="record['data']"  v-bind:download="record['name']" v-bind:id="record['Id']">
                  <div class="slds-truncate"  >
                    {{getFieldValue(record,col.name) | filter(col.type) }}
                  </div>
                </a>

                <span v-if="index>0" class="slds-truncate">

                  <span v-if="col.type=='alert' && record[col.name]" class="slds-icon_container slds-icon-utility-announcement" v-bind:title="$t('Alert')">
                    <svg class="slds-icon slds-icon-text-default slds-icon_x-small" aria-hidden="true">
                      <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#alert"></use>
                    </svg>
                    <span class="slds-assistive-text">Alert</span>
                  </span>
                  
                  {{getFieldValue(record,col.name) | filter(col.type) }}
                  
                </span>

              </td>

            </tr>
          </tbody>
        </table>
        <div v-if="!foto.length">
          <div v-if="statoscatti=='DA SCATTARE'">
            Le immagini di questo articolo sono in corso di realizzazione e saranno caricati a breve. 
          </div>
          <div v-if="statoscatti=='NON PREVISTO'">
            Le immagini di questo articolo non sono previste e non saranno caricate sul portale.
          </div>
          <div v-if="statoscatti=='DA CONFERMARE'">
            Le immagini di questo articolo non sono disponibili. Articolo non confermato. 
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>

// @ is an alias to /src
// import numeral from 'numeral'
import gnetHeader from '../components/header.vue'
import gnetTabBar from '../components/tabbar.vue'
import gnetTable from '../components/table.vue'
import gnetSpinner from '../components/spinner.vue'
import gnetTabs from '../components/tabs.vue'
import apiclient from '@/apiclient.js'
import gnetMixLib from '@/mixin.js'
import moment from 'moment'
import numeral from 'numeral'
import modal from '../components/modal.vue'
import gnetExpandable from '../components/expandable.vue'

export default {
  name: 'Prodotti',
  mixins: [gnetMixLib],
  components: {
    gnetHeader,
    gnetTabBar,
    gnetTable,
    gnetTabs,
    gnetSpinner,
    modal,
    gnetExpandable
  },
  filters: {
    filter: function(v, type) {
      switch(type) {
        case 'date':
          if (v) {
            var n=new moment(v);
            return n.format('DD/MM/YYYY');
          }
          return v;
        case 'decimal':
          if (v)
            return numeral(v).format('0,0');
          return v;
        case 'currency':
          if (v)
            return numeral(v).format('$ 0,0.00');
          return v;
        case 'dimension':
          if (v)
            return numeral(v).format('0,0');
          return v;
        case 'alert':
            if (!v)
              return '';
            return '';
        case 'truncate':
          if (v)
            return v.substr(0,32);
      }
      return v;
    }
  },
  data: function() {
    return {
      itemMap: new Map(),
      showElenco: false,
      colsfoto:[
        { order: 1, value:'', label:'Nome file', name:'name', type:'string' },
        { order: 2, value:'', label:'Dimensione', name:'size', type:'dimension' },
        { order: 3, value:'', label:'', name:'status', type:'string' },
      ],
      foto:[],
      imgname:'',
      imgdata:'',
      csvdata:'',
      downloadready:false,
      statoscatti:'',
      
      showpdfordini: false,
      showpdf: false,
      showpdfnolinee: false,
      showTimeline: false,
      listordini: true,
      listfatture: false,
      listcredito: false,
      listdocumenti: false,

      listmode: true,

      busy: false,
      recordId:this.$store.getters.connection.userdata.AccountId,
      record: {},
      create:false,

      filtrocampagneO:[true,false,false,false,false,false],
      filtrocampagneF:[false,false,false,false,false,false],
      ticketfields:[],
      ticketLastCreated:'',

      tickets:[],
      tasks:[],

      campagna:'',

      linee:[],

      ordinicols:[],
      ordini:[],

      partitecols:[],
      partite:[],
      campipartite:[],

      documenticols:[],
      documenti:[],
      ordiniCompleti:[],
      fattureComplete:[],

      fatturecols:[],
      fatture:[],
      campifatture:[],

      ordinidetailcols:[],
      ordinidetail:[],
      campiordinidetail:[],

      fields:[],
      fieldsstring: '',
      headlineFields: [],
      documentiActions: [  ],
      ordiniActions: [ {title: 'Scarica CSV', name:'scaricacsv', symbol:'download', id:'scaricacsvid' },  ],
      fattureActions: [ {title: 'Genera Pdf No Linee', name:'generapdfnolinee', symbol:'task'}, {title: 'Genera Pdf', name:'generapdf', symbol:'task'}, ],
      headlineActions: [ {title: 'NikePad', name:'nikepad', symbol:''}, {title:'Dati', name:'liste', symbol:''}, {title: 'Assegni', name:'assegni', symbol:''}, {title:'Qualifica', name:'qualifica', symbol:''} ],
      timelineActions: [ {title: 'Nuovo Ticket', name:'ticket', symbol:''}, {name:'newtask', symbol:'', title:'Nuova Attività'}],
      sections:[],

      timeline: [],

      editTask: false,
      showAssegni: false,
      editTicket:false,
      showQualifica:false,

      csvbuf:'',

      dati: {
        Name:'',
        Codice_Subentro__c:'',
        Insegna__c:'',

        BillingStreet:'',
        BillingCity:'',
        BillingPostalcode:'',
        BillingState:'',

        Referente__c:'',
        Phone:'',
        Fax:'',
        Email__c:'',

        P_Iva__c:'',
        IBAN__c:'',
        Codice_Fatturazione_Elettronica__c:'',
        PEC__c:'',

        Spedire__c:'',
        ShippingStreet:'',
        ShippingCity:'',
        ShippingPostalcode:'',
        ShippingState:'',

        Referente_Consegne__c:'',
        Orari__c:'',

        Tipologia__c:'',
        Ubicazione__c:'',
        Contratto__c:'',
        Competitors__c:'',
        Description:''

      }

    };
  },
  watch: {
  },
  mounted: function() {

    if (!this.campagna) this.campagna=this.$store.state.campagne[0];

    this.setupHeaderFields();
    this.setupQueryFields();
    this.getLinee();
    this.updateCustomer();

  },
  computed: {
    title: function() {
        if (this.record) 
          return this.record.Ragione_Sociale__c; // +' | '+this.record.Codice_2019__c;
        return '';
    },
    annocampagna: function() {
      return this.campagna.substr(0,4);
    },
    tipocampagna: function() {
      return this.campagna.substr(5,2);
    }
  },
  methods: {
    changeOrdini: function(event) {
      if (event=='scaricacsv') {
        var x=document.getElementById('downloadcsv');
        x.click();
      }
    },
    downloadAll: function() {
      if (!this.downloadready) return;
      this.foto.forEach(function(f) {
        var x=document.getElementById(f.id);
        x.click();
      })
    },
    align: function(type) {
      switch(type) {
        case 'currency':
        case 'decimal':
        case 'dimension':
          return 'right';
      }
      return 'left';
    },
    hexEncode : function(str){
        var hex, i;
        var result = "";
        for (i=0; i<str.length; i++) {
            hex = str.charCodeAt(i).toString(16);
            result += ("000"+hex).slice(-4);
        }
        return result
    },
    clickFoto: function(event) {
      var self=this;
      apiclient.getasset(this.$store.getters.connection, event.id).then(function(data) {        
        if (event.id.length==36 ) {
          console.log('nuovo modo');
          console.log(data.data);
          // console.log(data.data.content.deliveryInfo[0].contentUrl);
          // console.log(data.data.content.deliveryInfo[0].sysMetadata[0].value);

//          event.data=data.data.content.deliveryInfo[0].contentUrl;

//          STRUTTURA THRON VECCHIO
          // event.data='data:image/png;base64,'+data.data.content.imagedata;
          // event.size=data.data.content.deliveryInfo[0].sysMetadata[0].value;

//          STRUTTURA THRONX
          event.data='data:image/png;base64,'+data.data.imagedata;



          self.$set(event,'status','immagine pronta');
          self.downloadready=true;
          self.foto.forEach(function(f) {
            if (f.status=='recupero immagine in corso') self.downloadready=false;
          })
        } else {
          self.$set(event,'status','immagine pronta');
          event.data='data:image/png;base64,'+data.data;
          // self.download(event.id, event.name, data.data );
          self.downloadready=true;
          self.foto.forEach(function(f) {
            if (f.status=='recupero immagine in corso') self.downloadready=false;
          })
        }
      });
    },
    download: function(fileId, filename, data) {

      this.imgname=filename;
      this.imgdata='data:image/png;base64,'+data;

      this.$nextTick(function() {
        var clickme=document.getElementById(fileId);
        clickme.click();
      })
    },
    clickArticle: function(event) {
      var self=this;
      var folders=[ ];

      // this.statoscatti=event.Status_Scatti__c;

      this.statoscatti=event.Status_Scatti__c;
      let kikkerland=event.FCP_ITEMPRODUCTLINEID__c_=='KIK';
      if(kikkerland){
        console.log('kikkerland');
        folders=['1l1RNScjMG98LXBIkbIn03QOPeAtagrUp'];
      }

      self.foto=[];
      console.log('getassetlist');
      console.log(folders);
      apiclient.getassetlist(this.$store.getters.connection, event.Codice_Item__c, folders).then(function(data) {
        console.log(data);
        if (data.data) {
          self.foto=[];
          if (folders.length>0) {
            let codice=event.Codice_Item__c+'_';
            data.data.forEach(function(f) {
              if (f.size && f.name.substring(0,codice.length)==codice ) {
                var foto={
                  status: 'recupero immagine in corso',
                  Id: f.id,
                  id: f.id,
                  name: f.name,
                  size: f.size,
                };
                self.foto.push(foto);
                self.clickFoto(foto);
              }
            })
          } else {
            if(data.data.items && data.data.items.length>0) {
              data.data.items.forEach(function(f) {
                let codice=event.Codice_Item__c+'_';
                if (f.details.locales[0].name.substring(0,codice.length)==codice ) {
                  var foto={
                    Id: f.id,
                    id: f.id,
                    name: f.details.locales[0].name,
                    size:'',
                    data:''
                  }
                  self.foto.push(foto);
                  self.clickFoto(foto);
                }
              });
            } else {
              self.statoscatti = 'NON PREVISTO'
            }
          }
        }
        self.showElenco=true;
      });
    },
    updateCustomer: function() {
      var self=this;
      this.getRecord().then(function() {

        self.setupOrdiniDetail();
        self.getOrdiniDetail();

        /*
        self.getTimeline();
        self.setupPartite();
        self.getPartite();

        self.setupFatture();
        self.getFatture();

        self.setupOrdini();
        self.getOrdini();

        self.setupOrdiniDetail();
        self.getOrdiniDetail();

        self.setupDocumenti();
        self.getOrdiniCompleti().then(function() {
          return self.getFattureComplete();
        }).then(function() {
          self.compilaDocumenti();
          console.log('finito');
        });
        */
      });
    },
    fixObject: function() {
      var fok=[
        "Insegna__c",
        "Referente__c",
        "Phone",
        "Fax",
        "Email__c",
        "Referente_Consegne__c",
        "Orari__c",
        "Tipologia__c",
        "Ubicazione__c",
        "Competitors__c",
        "Description"
      ];
      var o={};
      for (var f in this.dati) {
        if (this.dati[f] && fok.indexOf(f)>=0) o[f]=this.dati[f];
      }
      return o;
    },
    updateAccount: function() {
      var mydata=this.fixObject();
      mydata.Data_Ultima_Modifica_da_Utente__c=new moment().format('YYYY-MM-DD')
      mydata.Utente__c=this.$store.state.user.email;
      //mydata.Id=this.recordId;
      this.busy=true;
      var self=this;
      apiclient.update(this.$store.getters.connection, 'Account', this.recordId, mydata).then(function(data) {
        self.showQualifica=false;
        self.busy=false;
      }).catch(function(err){
        self.showQualifica=false;
        self.busy=false;
      })
      
    },
    setDati: function(n) {
        this.dati[n]=this.record[n];
    },
    editAccount: function() {      
      this.showQualifica=true;

      this.setDati('Name');
      this.setDati('Codice_2019__c');
      this.setDati('FCP_ACCOUNTNUMSALESREP__c');
      this.setDati('CompanyIdHubspot__c');
      this.setDati('CompanyIdFreshdesk__c');
      this.setDati('Codice_Subentro__c');
      this.setDati('Insegna__c');

      this.setDati('BillingStreet');
      this.setDati('BillingCity');
      this.setDati('BillingPostalcode');
      this.setDati('BillingState');

      this.setDati('Referente__c');
      this.setDati('Phone');
      this.setDati('Fax');
      this.setDati('Email__c');

      this.setDati('P_Iva__c');
      this.setDati('IBAN__c');
      this.setDati('Codice_Fatturazione_Elettronica__c');
      this.setDati('PEC__c');

      this.setDati('Spedire__c');

      this.setDati('ShippingStreet');
      this.setDati('ShippingCity');
      this.setDati('ShippingPostalcode');
      this.setDati('ShippingState');

      this.setDati('Referente_Consegne__c');
      this.setDati('Orari__c');

      this.setDati('Tipologia__c');
      this.setDati('Ubicazione__c');
      this.setDati('Contratto__c');
      this.setDati('Competitors__c');
      this.setDati('Description');

    },
    setField: function(e) {
      var n=e.name;
      var v=e.value;
      var n2=n.substr(n.indexOf(".")+1)
      this.dati[n2]=v;
    },
    actionClick: function(e) {
      switch (e) {
        case 'nikepad':
          window.open('fcpnike://order/customer/'+this.record.FCP_ACCOUNTNUMSALESREP__c,'_blank');          
        break;
        case 'liste':
          this.listmode=!this.listmode;
        break;
        case 'newtask':
          this.editTask=true;
        break;
        case 'assegni':
          this.showAssegni=true;
        break;
        case 'ticket':
          if (this.record.CompanyIdHubspot__c)
            this.editTicket=true;
        break;
        case 'qualifica':
          this.editAccount();
        break;
        case 'generapdfordini':
          this.showpdfnolinee=false;
          this.showpdfordini=true;
        break;
        case 'generapdfordininolinee':
          this.showpdfnolinee=true;
          this.showpdfordini=true;
        break;
        case 'generapdf':
          this.showpdfnolinee=false;
          this.showpdf=true;
        break;
        case 'generapdfnolinee':
          this.showpdfnolinee=true;
          this.showpdf=true;
        break;
        case 'test':
          this.sendEmail();
        break;
        case 'cedente':
          this.$router.push({ name:'CustomerForm', params: { id: this.record.FCP_PREVIOUSCUST__c, record: this.record } });
        break;
      }
    },
    getRecord: function() {
      var self=this;
      return new Promise(function(resolve, reject) {
        var soql='select '+self.fieldsstring+' from Account where id=\''+self.recordId+'\' ';
        if (self.recordId.substring(0,3)!="001") { // non è un id salesforce
          soql='select '+self.fieldsstring+' from Account where Codice_2019__c=\''+self.recordId+'\' ';
        }
        //this.busy=true;
        apiclient.query(self.$store.getters.connection, soql).then(function(data) {
          self.busy=false;
          self.record={};
          if (data.length>0) {
            self.record=data[0];
            self.recordId=data[0].Id;
            self.documentiActions.splice(0,1);
            if (self.record.FCP_PREVIOUSCUST__c) {
              self.documentiActions.push( {title: 'Vai a cedente', name:'cedente', symbol:'change_owner'} );
            }
          }
          self.updateRecordFields();
          resolve();
        }).catch(function(err){
          console.log(err);
          reject();
        })
      })
    },
    getOrdini: function() {
      var self=this;
      // var fields="FCP_ITEMPRODUCTLINEID__c, Codice_Item__c, Descrizione_Item__c, avg(Prezzo_vendita__c) Prezzo_vendita__c, avg(Sconto__c) Sconto__c, sum(Quantita_ordinata__c) Quantita_ordinata__c, sum(Totale_Riga__c) Totale_Riga_Old__c, sum(Totale_Riga_Corretto__c) Totale_Riga__c, isGiusti__c";
      var fields="FCP_ITEMPRODUCTLINEID__c, Codice_Item__c, Descrizione_Item__c, Prodotto__r.Status_Scatti__c, avg(Prodotto__r.N_Scatti__c)";
      var soql='select '+fields+' from Riga_Ordine__c where ( ordine__r.Account__c=\''+this.recordId+'\' or ordine__r.Account_Spedizione__c=\''+this.recordId+'\' ) and ordine__r.isGiusti__c=false and ID_Campagna__c=\''+this.tipocampagna+'\' and FCP_COPYCMSYEAR__c=\''+this.annocampagna+'\' ';
      // soql+=' group by isGiusti__c, FCP_ITEMPRODUCTLINEID__c, Codice_Item__c, Descrizione_Item__c order by FCP_ITEMPRODUCTLINEID__c, Descrizione_Item__c';
      soql+=' group by FCP_ITEMPRODUCTLINEID__c, Codice_Item__c, Descrizione_Item__c, Prodotto__r.Status_Scatti__c order by FCP_ITEMPRODUCTLINEID__c, Codice_Item__c, Descrizione_Item__c';
      //this.busy=true;
      // console.log(soql);
      apiclient.query(this.$store.getters.connection, soql).then(function(data) {
        self.busy=false;
        self.ordini=data;
        self.updateRecordFields();
      }).catch(function(err){
        console.log(err);
      })
    },
    getAssortimenti: function() {
      var items=[... this.itemMap.keys() ];
      items=items.join("', '");
      var soql='select Assortimento__r.Name, Prodotto__r.Name, Prodotto__r.Description from Prodotto_Assortimento__c where Assortimento__r.FCP_ASSORTMENT__c=\'2\' and Assortimento__r.Name in (\''+items+'\' )';
      console.log(soql);
      return apiclient.query(this.$store.getters.connection, soql);
    },
    compilaOrdini: function(records, assortiti) {
        var campagna='', rcampagna={};
        var linea='', rlinea={};

        var codiciassortimenti=new Map();
        assortiti.forEach((a) => {
          codiciassortimenti.set(a.Assortimento__r.Name);
        })

        var csvrecord=[];

        this.ordinidetail.splice(0, this.ordinidetail.length);
        records.forEach( (r) => {
          this.itemMap.set(r.FCP_ITEMPRODUCTLINEID__c);
          if (campagna!=r.ID_Campagna__c) {
            rcampagna={Codice_Item__c:r.ID_Campagna__c, Descrizione_Item__c: '= = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = ', Totale:0, isbold:true };
            //this.ordinidetail.push(rcampagna);
            campagna=r.ID_Campagna__c;
          }
          if (linea!=r.FCP_ITEMPRODUCTLINEID__c) {
            var desclinea=this.linee.find(function(v) { return v.Name==r.FCP_ITEMPRODUCTLINEID__c; });
            var descrizione=(desclinea?desclinea.Descrizione__c:'');
            rlinea={Codice_Item__c:r.FCP_ITEMPRODUCTLINEID__c, Descrizione_Item__c:descrizione, Totale:0, isbold:true};
            this.ordinidetail.push(rlinea);
            linea=r.FCP_ITEMPRODUCTLINEID__c;
          }
          rcampagna.Totale+=r.Totale;
          rlinea.Totale+=r.Totale;
          r.ID_Campagna__c='';
          this.ordinidetail.push(r);
          csvrecord.push(r);

          if (codiciassortimenti.has(r.Codice_Item__c)) { // esplode assortimento
            assortiti.forEach((a) => {
              if (a.Assortimento__r.Name==r.Codice_Item__c) {
                var rassortimento={Codice_Item__c:a.Prodotto__r.Name, Descrizione_Item__c:a.Prodotto__r.Description };
                this.ordinidetail.push(rassortimento);
              }
            })
          }

        }, this);
        this.csvbuf=this.createCSV(csvrecord);
    },
    createCSV: function(records) {
      var buf="Codice, Descrizione, PVP, Stato, N.Scatti\n";
      records.forEach(function(r) {
        buf+=r.Codice_Item__c+',"'+r.Descrizione_Item__c+'",'+r.pvp+','+r.Status_Scatti__c+','+r.nscatti+'\n';
      })
      this.csvdata='data:text/csv;base64,'+btoa(buf);

      return buf;
    },
    getLinee: function() {
      var self=this;
      var soql='select Name, Descrizione__c from Linea__c ';

      this.busy=true;
      apiclient.query(this.$store.getters.connection, soql).then(function(data) {
        self.linee=data;
        self.busy=false;
      }).catch(function(err){
        console.log(err);
      })
    },
    getOrdiniDetail: function() {
      var self=this;
      var fields=" Codice_Item__c, ID_Campagna__c, Descrizione_Item__c, FCP_ITEMPRODUCTLINEID__C, avg(FCP_FINALSALESPRICE__c) pvp, Prodotto__r.Status_Scatti__c, avg(Prodotto__r.N_Scatti__c) nscatti ";
//      var fields=" Codice_Item__c, ID_Campagna__c, Descrizione_Item__c, avg(FCP_FINALSALESPRICE__c) pvp, Prodotto__r.Status_Scatti__c, avg(Prodotto__r.N_Scatti__c) nscatti ";
      var soql='select '+fields+' from Riga_Ordine__c where ';
      var campagneattive=[];
      this.filtrocampagneO.forEach(function(f,i) {
        if (f) { 
          let c=this.$store.state.campagne[i];
          campagneattive.push("'"+c+"'");
          if (c=='2025 VF') {
            campagneattive.push("'2025 VS'");
          }
          if (c=='2024 KK') {
            campagneattive.push("'2024 KC'");
            campagneattive.push("'2024 KP'");
          }
        }
      }, this);
      if (campagneattive.length==0) campagneattive.push("'nessuna'");

      soql+=" AnnoCampagna__c in ("+campagneattive.join(',')+") ";
      soql+="and ( Ordine__r.Account__c='"+this.recordId+"' or ordine__r.Account_Spedizione__c='"+this.recordId+"' ) and Foto_Visibili__c=true ";
      soql+=" group by Codice_Item__c, ID_Campagna__c, Descrizione_Item__c, FCP_ITEMPRODUCTLINEID__c, Prodotto__r.Status_Scatti__c ";
      soql+=" order by ID_Campagna__c, FCP_ITEMPRODUCTLINEID__c, Codice_Item__c ";
      console.log(soql)
      //this.busy=true;
      apiclient.query(this.$store.getters.connection, soql).then((data) => {

        console.log(data);
        data.forEach((r)=> {
          this.itemMap.set(r.Codice_Item__c);
          if (r.FCP_ITEMPRODUCTLINEID__c){
            r.FCP_ITEMPRODUCTLINEID__c_=r.FCP_ITEMPRODUCTLINEID__c;
            delete r.FCP_ITEMPRODUCTLINEID__c;
          }
        })

        this.getAssortimenti().then((assortiti) => {
          console.log('assortiti');
          console.log(assortiti);
          self.busy=false;
          self.compilaOrdini(data, assortiti);
        })
      }).catch(function(err){
        console.log(err);
      })
    },
    changeCampagna: function(index) {
      this.campagna=this.$store.state.campagne[index];
      this.getOrdini();
    },
    changeCampagnaOrdini: function(index) {
      this.filtrocampagneO.fill(false);
      this.filtrocampagneO[index]=true;
      this.getOrdiniDetail();
    },
    changeCampagnaFatture: function(index) {
      this.filtrocampagneF[index]=!this.filtrocampagneF[index];
      this.getFatture();
    },
    updateRecordFields: function() {
      // this.recordId=this.$route.params.id;
      // this.record=this.$route.params.record;
      // header
      this.updateFieldsValue(this.headlineFields);
      // record
      this.campipartite.forEach(function(s) {
        this.updateFieldsValue(s.fields);
      }, this);
    },
    compilaDocumenti: function() {
      var levelKey='', levelRecord={};
      var dati=this.fattureComplete.concat(this.ordiniCompleti);
      dati.sort(function(a,b) {
        if (a.timestamp==b.timestamp) {
          if (a.Tipo=='Ordine' && b.Tipo=='Fattura') return -1;
          if (a.Tipo=='Fattura' && b.Tipo=='Ordine') return 1;
          // return 0;
          return a.Riga<b.Riga;
        } else {
          return b.timestamp-a.timestamp;
        }
      });
      var lastadd=-2;
      var dati2=[];
      dati.forEach(function(r,i) {
        if (lastadd!=(i-1)) {
          if (levelKey!=r['Documento']) {
            var nr={ nRecord:0, sommaSconto:0, Totale:0, isbold:true, Id:r.custaccount,  Quantita:0, Sconto:0 };
            nr.Codice=r.Data;
            nr.Descrizione=r.Tipo+" "+r.Documento;
            if(r.Tipo == 'Fattura') nr.TotFattura=r.Importo;
            nr.Linea=r.Tipo2;
            levelRecord=nr;    

            nr.Documento=r.Documento,
            nr.Riga=r.Riga,
            nr.Data=r.Data,
            nr.Tipo=r.Tipo,

            dati.splice(i,0,levelRecord);
            dati2.push(levelRecord);
            levelKey=r['Documento'];
            lastadd=i;
          }
          levelRecord.nRecord+=1;
          levelRecord.Totale+=r.Totale;
          levelRecord.Quantita+=r.Quantita;

          if (r.Quantita) {
            levelRecord.sommaSconto+=r.Sconto/100*r.Totale;
            if (levelRecord.Quantita!=0)
              levelRecord.Sconto=levelRecord.sommaSconto/levelRecord.Totale*100;
          }
        }
      }, this);
      this.documenti=dati;      
    },
    setupOrdiniDetail: function() {
      var ord=1;      
      this.ordinidetailcols.splice(0,this.ordinidetailcols.length);
      // this.ordinidetailcols.push( { order: ord++, value:'', label:'CC', name:'FCP_COPYCMSCAMPAIGNID__c', type:'string' } );
      this.ordinidetailcols.push( { order: ord++, value:'', label:'Codice', name:'Codice_Item__c', type:'string' } );
      this.ordinidetailcols.push( { order: ord++, value:'', label:'Descrizione', name:'Descrizione_Item__c', type:'string' } );
      this.ordinidetailcols.push( { order: ord++, value:'', label:'PVP', name:'pvp', type:'currency' } );

      // this.ordinidetailcols.push( { order: ord++, value:'', label:'Stato', name:'Status_Scatti__c', type:'string' } );

      // this.ordinidetailcols.push( { order: ord++, value:'', label:'N.Scatti', name:'nscatti', type:'decimal' } );
      /*
      this.ordinidetailcols.push( { order: ord++, value:'', label:'Imp.Totale', name:'Totale', type:'currency' } );
      this.ordinidetailcols.push( { order: ord++, value:'', label:'Linea', name:'FCP_ITEMPRODUCTLINEID__c', type:'string' } );
      this.ordinidetailcols.push( { order: ord++, value:'', label:'Ven.', name:'Quantita_Ordinata', type:'decimal' } );
      this.ordinidetailcols.push( { order: ord++, value:'', label:'Om.', name:'Quantita_Omaggio', type:'decimal' } );
      this.ordinidetailcols.push( { order: ord++, value:'', label:'Rese', name:'Quantita_Rese', type:'decimal' } );
      this.ordinidetailcols.push( { order: ord++, value:'', label:'Ann.', name:'Quantita_Annullata', type:'decimal' } );
      this.ordinidetailcols.push( { order: ord++, value:'', label:'Tot', name:'Quantita_Totale', type:'decimal' } );
      this.ordinidetailcols.push( { order: ord++, value:'', label:'Sc %', name:'Sconto', type:'decimal' } );
      */
    },
    setupQueryFields: function() {
      var mfields=new Map();

      // id e name sempre
      mfields.set('Id', null);
      mfields.set('Name', null);
      mfields.set('Ragione_Sociale__c', null);
      mfields.set('Codice_2019__c', null);
      mfields.set('FCP_ACCOUNTNUMSALESREP__c', null);
      mfields.set('FCP_PREVIOUSCUST__c', null);
      
      mfields.set('Credito_Aperto__c', null);
      mfields.set('N_Partite_Aperte__c', null);
      mfields.set('Credito_Futuro__c', null);
      mfields.set('N_Partite_Future__c', null);
      mfields.set('Credito_Scaduto__c', null);
      mfields.set('N_Partite_Scadute__c', null);
      mfields.set('Data_Prossima_Scadenza__c', null);
      mfields.set('Data_Primo_Credito_Scaduto__c', null);

      mfields.set('CompanyIdHubspot__c', null);
      mfields.set('CompanyIdFreshdesk__c', null);
      mfields.set('Referente_CC__c', null);
      mfields.set('Referente_CR__c', null);
      mfields.set('Zona_1__c', null);
      mfields.set('Zona_2__c', null);
      mfields.set('Codice_Subentro__c', null);
      mfields.set('Insegna__c', null);

      mfields.set('BillingStreet', null);
      mfields.set('BillingCity', null);
      mfields.set('BillingPostalcode', null);
      mfields.set('BillingState', null);

      mfields.set('Referente__c', null);
      mfields.set('Phone', null);
      mfields.set('Fax', null);
      mfields.set('Email__c', null);

      mfields.set('P_Iva__c', null);
      mfields.set('IBAN__c', null);
      mfields.set('Codice_Fatturazione_Elettronica__c', null);
      mfields.set('PEC__c', null);

      mfields.set('Spedire__c', null);

      mfields.set('ShippingStreet', null);
      mfields.set('ShippingCity', null);
      mfields.set('ShippingPostalcode', null);
      mfields.set('ShippingState', null);

      mfields.set('Referente_Consegne__c', null);
      mfields.set('Orari__c', null);

      mfields.set('Tipologia__c', null);
      mfields.set('Ubicazione__c', null);
      mfields.set('Contratto__c', null);
      mfields.set('Competitors__c', null);
      mfields.set('Description', null);

      // header
      this.mapFields(mfields, this.headlineFields);
      // record
      this.sections.forEach(function(s) {
        this.mapFields(mfields, s.fields);
      },this);
      // riassume
      this.fields=this.uniqueFields(mfields);
      this.fieldsstring=this.fields.join(',');
    },
    setupHeaderFields: function() {
      this.headlineFields.splice(0,this.headlineFields.length);
      this.headlineFields.push( { value:'', label:'Codice', name:'Codice_2019__c', type:'string' } );
      this.headlineFields.push( { value:'', label:'Ultimo Ordine', name:'Data_Ultimo_Ordine_AX__c', type:'date' } );
      this.headlineFields.push( { value:'', label:'Ordini AC', name:'Totale_Ordinato_AX__c', type:'currency'} );
      this.headlineFields.push( { value:'', label:'Telefono', name:'Phone', type:'string'} );
      this.headlineFields.push( { value:'', label:'Email', name:'Email__c', type:'email' } );
    },
  }
}
</script>

<style scoped>
.bottonesplit {
    width: 0.75rem;
    background: white;
    border-radius: 0;
    border: 1px solid #dddbda;
}
</style>

